// Last-calc / dirty / error status cell. Renders below the Calculate
// band-row, one cell per instrument. Matches MVP StatusBand semantics:
// inputs-changed warning, error message, or last calc timestamp.
import { FC, useContext } from 'react';
import { Typography } from '@mui/material';

import { PricingContext } from '../../../../providers/exotics-pricing-provider';

export const StatusCell: FC<{ instrumentId: string }> = ({ instrumentId }) => {
  const { dirty, calculatedAt, errors, loading } = useContext(PricingContext);
  const isLoading = !!loading[instrumentId];
  const isDirty = !!dirty[instrumentId];
  const error = errors[instrumentId];
  const lastCalc = calculatedAt[instrumentId];

  if (isLoading) {
    return (
      <Typography sx={{ fontSize: 10, color: 'text.secondary', textAlign: 'right' }}>
        Calculating…
      </Typography>
    );
  }
  if (error) {
    return (
      <Typography sx={{ fontSize: 10, color: 'error.main', textAlign: 'right' }}>
        {error}
      </Typography>
    );
  }
  if (isDirty) {
    return (
      <Typography sx={{ fontSize: 10, color: 'warning.main', textAlign: 'right' }}>
        inputs changed — recompute
      </Typography>
    );
  }
  if (lastCalc) {
    return (
      <Typography sx={{ fontSize: 10, color: 'text.disabled', textAlign: 'right' }}>
        last calc {new Date(lastCalc).toLocaleTimeString()}
      </Typography>
    );
  }
  return (
    <Typography sx={{ fontSize: 10, color: 'text.disabled', textAlign: 'right' }}>
      not yet calculated
    </Typography>
  );
};
